import { render } from "./LandingPage.vue?vue&type=template&id=56724177&scoped=true"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"

import "./LandingPage.vue?vue&type=style&index=0&id=56724177&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-56724177"

export default script